import { Component, Input, OnInit } from '@angular/core';
import { AlertMapService } from 'src/app/main/side-bar/alert/alert-map.service';
import { AlertMapConstants, VisibilityMapConstants } from 'src/app/main/side-bar/alert/alert-gis/alert-gis.const';
import { AlertDataService } from 'src/app/main/side-bar/alert/alert-data.service';
import { ActivatedRoute, Params } from '@angular/router';
import { isNullOrUndefined } from '@swimlane/ngx-datatable';

@Component({
  selector: 'app-layercontrol',
  templateUrl: './layercontrol.component.html',
  styleUrls: ['./layercontrol.component.scss']
})
export class LayercontrolComponent implements OnInit {
  @Input() mapObj : any;
  @Input()layersList : any;
  @Input() activeLayers : any;
  @Input() gisMapComp;

  WSA_source:string ='SENTINEL_1';
  map: any;
  legend: any ;
  params : any
  deviationParams : any = null
  WSALayers:any= {};
  urlParams: any;
  // inflowIndex : any = this.utilsSrv.getCurrentInflowTimestep();
  inflowOptions :  any = {};
  constructor(private utilsSrv: AlertDataService,
              private gisService: AlertMapService,
              private route:ActivatedRoute
              ) { }

  ngOnInit() {
    this.route.queryParamMap.subscribe((params: Params) => {
      this.urlParams = params.params;     
    })
    this.utilsSrv.getSelectedParams().subscribe(params =>{
      if(!this.utilsSrv.isEmptyObj(params))
      this.params = params;
    })
    // this.utilsSrv.getInflowOptions().subscribe(options =>{
    //   if(!this.utilsSrv.isEmptyObj(options)){
    //     this.inflowOptions = options;
    //     this.inflowIndex = options.selectedDate ? options.selectedDate : this.inflowIndex;
    //   }
    // })
    this.getWaterSpreadWSALayers(this.layersList);
    this.WSA_source = this.gisService.getVisibilityMiTanksSource();
  }

  accordianOnClick(event) {
    let target = event.target || event.srcElement || event.currentTarget;
    /* Toggle between adding and removing the "active" class,
    to highlight the button that controls the panel */
    target.classList.toggle("active");

    /* Toggle between hiding and showing the active panel */
    let panel = target.nextElementSibling as HTMLElement;
    if (panel.style.display === "block") {
      panel.style.display = "none";
    } else {
      panel.style.display = "block";
    }
  }

  checkISLayerApplicable(layerName){
    let layerArr = [ "Telangana Basin Depth_Class","Telangana Depth_Class","Depth_Class","Depth_Class2"], isRequired = false;
    if(layerName != undefined && layerName != null){
      let index = layerArr.findIndex(layer => layer == layerName);
      if(index>-1){
        isRequired = true;
      }
    }
    // console.log("\n In checkISLayerApplicable :: isRequired",isRequired,"\n layerName",layerName,"\n layerArr",layerArr);
    return isRequired;
  }

  showAndHideLayer(layer,base,dateChange?){
    // console.log("\n In showAndHideLayer :: gisMapComp",this.gisMapComp,"\n layer",layer,"\n this.activeLayers",this.activeLayers);
     if(base){
       for (const key in this.layersList.baselayers) {
         if (this.layersList.baselayers.hasOwnProperty(key)) {
           const value = this.layersList.baselayers[key];
           if(this.mapObj.hasLayer(value))
           this.mapObj.removeLayer(value);
           value.options.visible = false;
         }
       }
       this.mapObj.addLayer(layer);
       layer.options.visible = true;
       return;
     }
    //  if(this.params && this.params.component === 'INFLOWFORECAST' && isNullOrUndefined(layer.options)){
    //   let Options : any = {...this.inflowOptions};
    //   let selLayer : any = '';
    //   let date : any = new Date(Number(this.inflowIndex));
    //   date = this.utilsSrv.getModelDateFromDate(date);
    //   if(layer == 'heatMap'){
    //     Options['isHeatMapLayer'] = !this.inflowOptions['isHeatMapLayer'];
    //     selLayer = this.inflowIndex.toString();
    //   }else if(layer == 'point'){
    //     Options['isPointLayer'] = !this.inflowOptions['isPointLayer'];
    //     selLayer = 'Inflow_Points_'+date;
    //   }else if(layer == 'riverflow'){
    //     Options['isRiverLayer'] = !this.inflowOptions['isRiverLayer'];
    //     selLayer = 'River_Flow_'+date;
    //   }
    //   // let layers :any = Object.keys(this.layersList.overlaylayers);
    //   this.utilsSrv.setInflowOptions(Options);
    //   // let index = layers.indexOf(layer);
    //   console.log('this.layersList.overlaylayers[layer] ::',this.inflowIndex,this.layersList.overlaylayers[selLayer],'\n',this.layersList.overlaylayers,'\n',selLayer)
    //   this.showAndHideLayer(this.layersList.overlaylayers[selLayer],false);
    //   return;
    //  }
     console.log("\n In showAndHideLayer, layer",layer,"\n layer.options.key",layer.options.key);
     if(layer.options.component == "INFLOWFORECAST" && dateChange ){
       this.gisMapComp.changeTimeLayers(Number (layer.options.groupName));
       return;
     }
     var is_deselect = false, isRequired = this.checkISLayerApplicable(layer.options.key);
     if(isRequired){
       let source =this.params['src'];
       if(layer.options.visible == true){
         if(this.gisMapComp && this.gisMapComp.injectedService){
           this.gisMapComp.injectedService[this.gisMapComp.otherOptions['handleLayerControlEvent']](this.gisMapComp,layer.options.key,'remove');
         }else{
           if(source){
             this.gisService.handleLayerControlEvent('remove',source);
           }else{
             this.gisService.handleLayerControlEvent('remove');
           }
         }
         if(this.activeLayers){
           this.activeLayers[layer.options.key] = false;
         }
         layer.options.visible = false;
       }else{
         if(this.gisMapComp && this.gisMapComp.injectedService){
           this.gisMapComp.injectedService[this.gisMapComp.otherOptions['handleLayerControlEvent']](this.gisMapComp,layer.options.key,'add');
         }else{
           if( source){
             this.gisService.handleLayerControlEvent('add',source);
             this.gisService.emitSourceChangeEvent(source);
           }else{
             this.gisService.handleLayerControlEvent('add');
           }
         }
         if(this.activeLayers){
           this.activeLayers[layer.options.key] = true;
         }
         layer.options.visible = true; 
       }
     }else{
      
       if (layer.options.key == "Telangana MiTank_Mandal_Structures Count" || layer.options.key == "Telangana MiTank_SubBasin Structures Count" || layer.options.key == "Telangana MiTank_Basin Structures Count" || layer.options.key=="Mandal Wc Structures count" || layer.options.key=="Wc Structures count" || layer.options.key=='WCS points') {
        let currentZoom = this.gisMapComp.map.getZoom(),minZoom = layer['options']['minZoom'],maxZoom = layer['options']['maxZoom'],
        params = this.gisMapComp.params;
        let bool = false;
        if(currentZoom>=minZoom && currentZoom<=maxZoom){
          bool = true;
        }
        // console.log("\n bool ",bool," \n layer",layer,"\n layer.options.visible)",layer.options.visible,"\n currentZoom ",currentZoom,"\n params ",params);
        if(layer.options.visible){
          if(this.mapObj.hasLayer(layer)){
            this.mapObj.removeLayer(layer);
          }
        }else{
          if(bool ||(
           (params['pType'] == VisibilityMapConstants.LOCATIONS.MITANK || 
            params['pType'] == VisibilityMapConstants.LOCATIONS.BLOCK ) && currentZoom>maxZoom
          )){
            if(!this.mapObj.hasLayer(layer)){
              this.mapObj.addLayer(layer);
            }
          }else{

          }
        }
        if(this.activeLayers){
          this.activeLayers[layer.options.key] = !layer.options.visible;
         }
        layer.options.visible = !layer.options.visible;
       }
       else{
        if(this.mapObj.hasLayer(layer)){
          this.mapObj.removeLayer(layer);
          if(this.activeLayers){
           this.activeLayers[layer.options.key] = false;
          }
          layer.options.visible = false;
          if(layer.options.hasOwnProperty('emitFromLayerControl') && layer.options.emitFromLayerControl){
            this.utilsSrv.setIsVisibleOfClusterLayer(false);
          }
        }else
         if (!is_deselect) {
          this.mapObj.addLayer(layer);
          if(this.activeLayers){
           this.activeLayers[layer.options.key] = true;
          }
          layer.options.visible = true;
          if(layer.options.hasOwnProperty('emitFromLayerControl') && layer.options.emitFromLayerControl){
            this.utilsSrv.setIsVisibleOfClusterLayer(true);
          }
        }
       }
     }
     if(this.gisMapComp && this.gisMapComp.params && this.gisMapComp.params['component']){
       this.gisMapComp.manageLegend();
     }
   }

  // showAndHideLayer(layer,base){
  //  // console.log("\n In showAndHideLayer :: gisMapComp",this.gisMapComp,"\n layer",layer,"\n this.activeLayers",this.activeLayers);
  //   if(base){
  //     for (const key in this.layersList.baselayers) {
  //       if (this.layersList.baselayers.hasOwnProperty(key)) {
  //         const value = this.layersList.baselayers[key];
  //         if(this.mapObj.hasLayer(value))
  //         this.mapObj.removeLayer(value);
  //         value.options.visible = false;
  //       }
  //     }
  //     this.mapObj.addLayer(layer);
  //     layer.options.visible = true;
  //     return;
  //   }
  //   console.log("\n In showAndHideLayer, layer",layer,"\n layer.options.key",layer.options.key);
  //   var is_deselect = false, isRequired = this.checkISLayerApplicable(layer.options.key);
  //   if(isRequired){
  //     let source =this.params['src'];
  //     if(layer.options.visible == true){
  //       if(this.gisMapComp && this.gisMapComp.injectedService){
  //         this.gisMapComp.injectedService[this.gisMapComp.otherOptions['handleLayerControlEvent']](this.gisMapComp,layer.options.key,'remove');
  //       }else{
  //         if(source){
  //           this.commonVisibilityService.handleLayerControlEvent('remove',source);
  //         }else{
  //           this.commonVisibilityService.handleLayerControlEvent('remove');
  //         }
  //       }
  //       if(this.activeLayers){
  //         this.activeLayers[layer.options.key] = false;
  //       }
  //       layer.options.visible = false;
  //     }else{
  //       if(this.gisMapComp && this.gisMapComp.injectedService){
  //         this.gisMapComp.injectedService[this.gisMapComp.otherOptions['handleLayerControlEvent']](this.gisMapComp,layer.options.key,'add');
  //       }else{
  //         if( source){
  //           this.commonVisibilityService.handleLayerControlEvent('add',source);
  //           this.gisService.emitSourceChangeEvent(source);
  //         }else{
  //           this.commonVisibilityService.handleLayerControlEvent('add');
  //         }
  //       }
  //       if(this.activeLayers){
  //         this.activeLayers[layer.options.key] = true;
  //       }
  //       layer.options.visible = true; 
  //     }
  //   }else{
  //     if(this.mapObj.hasLayer(layer)){
  //       this.mapObj.removeLayer(layer);
  //       if(this.activeLayers)
  //       this.activeLayers[layer.options.key] = false;
  //       layer.options.visible = false;
  //     }else
  //      if (!is_deselect) {
  //       this.mapObj.addLayer(layer);
  //       if(this.activeLayers)
  //       this.activeLayers[layer.options.key] = true;
  //       layer.options.visible = true;
  //     }
  //   }
  //   if(this.gisMapComp && this.gisMapComp.params && (this.gisMapComp.params['component']== this.gisMapComp.gisMapConst.COMPONENT.SOILMOISTURE ||
  //   this.gisMapComp.params['component']== this.gisMapComp.gisMapConst.COMPONENT.RESERVOIR || 
  //   this.gisMapComp.params['component']== this.gisMapComp.gisMapConst.COMPONENT.CROPDEMAND )){
  //     this.gisMapComp.manageLegend();
  //   }
  // }

  WaterSpreadLayerControl(layer,removeLayer){
    let source1=null,source2 = null;
  
    if(layer.options.key == 'Depth_Class'){
      source1 ='SENTINEL_1',source2 ='SENTINEL_2';
    }else if(layer.options.key == 'Depth_Class2'){
      source1 ='SENTINEL_2', source2 ='SENTINEL_1';
    }

    this.gisService.handleLayerControlEvent('add',source1);
    this.gisService.handleLayerControlEvent('remove',source2);

    this.gisService.emitSourceChangeEvent(source1);
      
    if(this.activeLayers){
      this.activeLayers[layer.options.key] = true;
      this.activeLayers[removeLayer.options.key] = false;
    }
    
  }
  changeWSASource(source){
    this.WaterSpreadLayerControl(this.WSALayers[source],this.WSALayers[this.getSource2(source)]);
  }
  getSource2(source){
    if(source== 'SENTINEL_1'){
      return 'SENTINEL_2';
    }else if(source == 'SENTINEL_2'){
      return 'SENTINEL_1';
    }
  }
  getWaterSpreadWSALayers(layersList){
    if(layersList && layersList.overlaylayers){

      Object.keys(layersList.overlaylayers).forEach(key => {
        //console.log("layersList.overlaylayers:::",layersList.overlaylayers);
        
        if(key == 'Depth_Class'){
          let layer=layersList.overlaylayers[key];
          // console.log('this.activeLayers[layersList.overlaylayers[key].value.options.key] ::[layer.value.options.key]',this.activeLayers ,layer);
          
          Object.assign(this.WSALayers,{'SENTINEL_1':layer});
        }else  if(key == 'Depth_Class_Sentinel2'){
          let layer=layersList.overlaylayers[key];
          Object.assign(this.WSALayers,{'SENTINEL_2':layer});
        }
      });
      // console.log(layersList.overlaylayers,this.WSALayers);

    }
  }

  isCurrentLayer(layerName :any){
    let flag : any ;
    // if(this.inflowIndex.toString() == layerName){
    //   flag =  true;
    // }else{
      flag = false;
    // }
    return flag;
  }
}
